/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { IOption } from "../../types/CommonTypes";
import { IRecipientTag } from "../../types/SavedSearchTypes";
import { ITag } from "../../types/TagTypes";
import StyledAutocompleteSelect from "../StyledAutoCompleteSelect/AutoCompleteSelect";
import TagSelect from "./TagSelect";

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  border: 1px dashed #cccccc;
  border-radius: 10px;
  padding: 40px;

  position: relative;

  .ekp3u414 {
    width: 80px;
    height: 40px;
    margin-left: 10px;
  }

  .envmntf9 {
    margin: 16px 0 0 0;
    grid-gap: 16px;

    > div {
      margin: 0;
    }
  }
`;

const Title = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  position: absolute;
  top: -11px;
  left: 10px;
  width: 45px;
  background-color: #ffffff;
`;

const CloseButton = styled.div`
  width: 24px;
  height: 24px;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: -11px;
  right: -8px;

  background-color: #ffffff;
  border: 1px solid #c41700;
  border-radius: 100%;

  transition: background-color 0.3s;

  :hover {
    background-color: #c4170030;
  }

  svg {
    color: #c41700;
  }
`;

const FlexRow = styled.div`
  width: 100%;

  margin-bottom: 10px;

  display: flex;
  align-items: center;
`;

export const OPTIONS_FILTER: IOption[] = [
  {
    value: "ANY_OF",
    name: "With any of these tags",
  },
  {
    value: "ALL_OF",
    name: "With all of these tags",
  },
  {
    value: "NONE_OF",
    name: "None of these tags",
  },
];

export const OPTIONS: IOption[] = [
  {
    value: "ALL",
    name: "All contacts",
  },
  ...OPTIONS_FILTER,
];
interface Props {
  recipientTag: IRecipientTag;
  index: number;
  removeRecipientTags: (recipientTag: IRecipientTag) => void;
  handleOptionRecipientTags: (option: IOption, index: number) => void;
  handleTagsRecipientTags: (tags: ITag[], index: number) => void;
  isFilterContact?: boolean;
  resetTagSelect?: boolean;
}

export default function TagSelectRecipient(props: Props): JSX.Element {
  const {
    recipientTag,
    index,
    removeRecipientTags,
    handleOptionRecipientTags,
    handleTagsRecipientTags,
    isFilterContact,
    resetTagSelect,
  } = props;

  const [selectedOption, setSelectedOption] = useState(
    isFilterContact && (!recipientTag || recipientTag.tags.length === 0)
      ? OPTIONS[0]
      : recipientTag.option
  );

  useEffect(() => {
    setSelectedOption(recipientTag.option);
  }, [recipientTag.option]);

  useEffect(() => {
    if (resetTagSelect) {
      if (!isFilterContact) {
        return;
      } else {
        setSelectedOption(OPTIONS[0]);
        handleOptionRecipientTags(OPTIONS[0], index);
      }
    }
  }, [resetTagSelect]);

  function handleRecipientMiddleware(tags: ITag[], index: number) {
    if (!tags.length && selectedOption !== OPTIONS[0]) {
      setSelectedOption(OPTIONS[0]);
      handleOptionRecipientTags(OPTIONS[0], index);
    } else {
      handleTagsRecipientTags(tags, index);
    }
  }

  function handleOptionSelect(option: IOption) {
    if (isFilterContact && option.name === "" && option.value === "") {
      handleOptionRecipientTags(OPTIONS[0], index);
      setSelectedOption(OPTIONS[0]);
    } else {
      handleOptionRecipientTags(option, index);
      setSelectedOption(option);
    }
  }

  return (
    <Container>
      <Title>Tags {index + 1}</Title>
      {index > 0 && (
        <CloseButton>
          <AiOutlineClose onClick={() => removeRecipientTags(recipientTag)} />
        </CloseButton>
      )}
      <FlexRow>
        <StyledAutocompleteSelect
          options={index === 0 ? OPTIONS : OPTIONS_FILTER}
          selectedOption={selectedOption}
          onOptionSelect={(option) => handleOptionSelect(option)}
          placeholder={"Type or select a filter option"}
        />
      </FlexRow>

      {recipientTag.option.value !== "ALL" && (
        <TagSelect
          tags={recipientTag.tags}
          handleChoseTags={(tags) => {
            isFilterContact
              ? handleRecipientMiddleware(tags, index)
              : handleTagsRecipientTags(tags, index);
          }}
        />
      )}
    </Container>
  );
}
